/**
 * .Farra — live-update product title with the currently-selected Chapter
 *
 * On the PDP, listens for radio input changes on the Chapter option and
 * mirrors the picked value into every [data-farra-title-chapter] span in
 * the title block. Dawn already emits input changes when the user picks
 * a swatch; this just tags along.
 *
 * Runs on any page that has [data-farra-title-chapter] elements — no
 * config or dependencies needed.
 */
(function () {
  // Populate the [data-farra-chapter-label] attribute on each Chapter swatch
  // label so my CSS ::after can surface it as a hover/selected tooltip.
  function decorateChapterSwatches() {
    const radios = document.querySelectorAll(
      'input[type="radio"][data-option-name="Chapter" i], input[type="radio"][data-option-name="chapter"]'
    );
    radios.forEach((radio) => {
      if (!radio.value) return;
      const label = radio.nextElementSibling;
      if (label && label.tagName === 'LABEL') {
        label.setAttribute('data-farra-chapter-label', radio.value);
        label.setAttribute('title', radio.value);
      }
    });
  }

  function updateChapterTitles() {
    const spans = document.querySelectorAll('[data-farra-title-chapter]');
    if (spans.length === 0) return;

    // Find any checked Chapter radio input on the page.
    const chapterRadio = document.querySelector(
      'input[type="radio"][name*="Chapter" i]:checked, input[type="radio"][data-option-name="Chapter" i]:checked, input[type="radio"][data-option-name="chapter"]:checked'
    );

    let value = null;
    if (chapterRadio) {
      value = chapterRadio.value;
    } else {
      // Fallback: read from the URL variant id → Shopify populates selected radios on load; if for some reason none is checked, leave the server-rendered value.
      return;
    }

    if (!value) return;
    spans.forEach((el) => {
      el.textContent = value;
    });
  }

  // Update on any radio change anywhere in the document — cheap and safe
  document.addEventListener('change', function (e) {
    const target = e.target;
    if (!target || target.tagName !== 'INPUT' || target.type !== 'radio') return;
    const name = (target.dataset.optionName || target.name || '').toLowerCase();
    if (name.includes('chapter')) {
      updateChapterTitles();
    }
  });

  function init() {
    decorateChapterSwatches();
    updateChapterTitles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
